import React from 'react';
import { UserIcon } from '@heroicons/react/24/outline';
import { resolveAvatarUrl } from '../../utils/avatarUrl';

const SIZE_CLASSES = {
  xs: {
    box: 'h-6 w-6 sm:h-8 sm:w-8 rounded-lg sm:rounded-xl',
    icon: 'h-3 w-3 sm:h-4 sm:w-4',
  },
  compact: {
    box: 'h-10 w-10 sm:h-12 sm:w-12 rounded-xl sm:rounded-2xl',
    icon: 'h-5 w-5 sm:h-6 sm:w-6',
  },
  sm: {
    box: 'h-12 w-12 rounded-2xl',
    icon: 'h-6 w-6',
  },
  md: {
    box: 'h-16 w-16 rounded-2xl',
    icon: 'h-8 w-8',
  },
  lg: {
    box: 'h-16 w-16 rounded-3xl',
    icon: 'h-8 w-8',
  },
  round: {
    box: 'h-16 w-16 rounded-full',
    icon: 'h-8 w-8',
  },
  xl: {
    box: 'h-32 w-32 rounded-3xl',
    icon: 'h-16 w-16',
  },
};

const FALLBACK_VARIANTS = {
  default: {
    wrapper: 'bg-gradient-to-br from-secondary-200 to-secondary-300  ',
    icon: 'text-secondary-600 ',
  },
  brand: {
    wrapper: 'bg-gradient-to-br from-orange-500 to-amber-500 shadow-soft',
    icon: 'text-white',
  },
};

function UserAvatar({
  src,
  alt = '',
  size = 'md',
  className = '',
  showFallbackIcon = true,
  variant = 'default',
}) {
  const sizeClass = SIZE_CLASSES[size] || SIZE_CLASSES.md;
  const fallback = FALLBACK_VARIANTS[variant] || FALLBACK_VARIANTS.default;
  const resolvedSrc = resolveAvatarUrl(src);

  if (resolvedSrc) {
    return (
      <img
        src={resolvedSrc}
        alt={alt}
        className={`${sizeClass.box} flex-shrink-0 bg-secondary-100 object-cover object-center  ${className}`}
      />
    );
  }

  if (!showFallbackIcon) {
    return (
      <div
        className={`${sizeClass.box} flex-shrink-0 ${fallback.wrapper} ${className}`}
      />
    );
  }

  return (
    <div
      className={`${sizeClass.box} flex flex-shrink-0 items-center justify-center ${fallback.wrapper} ${className}`}
    >
      <UserIcon className={`${sizeClass.icon} ${fallback.icon}`} />
    </div>
  );
}

export default UserAvatar;
